/**
 * Vehicle detail page copy and status enums (Milestone 7).
 */

export const VEHICLE_DETAIL_PAGE_STATUS = {
  LOADING: "loading",
  READY: "ready",
  NOT_FOUND: "not_found",
  UNAVAILABLE: "unavailable",
  ERROR: "error",
};

/** Max similar listings shown on the public vehicle detail page. */
export const VEHICLE_DETAIL_SIMILAR_LISTINGS_LIMIT = 8;

export const VEHICLE_DETAIL_COPY = {
  loadingPrimary: "Cargando vehículo…",
  loadingSecondary: "Cargando detalles…",
  errorTitle: "No pudimos cargar este vehículo.",
  errorBody: "Intenta nuevamente o vuelve a la búsqueda.",
  retry: "Reintentar",
  backToSearch: "Volver a resultados",
  notFoundTitle: "No encontramos este vehículo.",
  notFoundBody:
    "Puede que la publicación haya cambiado, se haya vendido o ya no esté disponible.",
  viewAvailable: "Ver vehículos disponibles",
  unavailableTitle: "Este vehículo ya no está disponible.",
  unavailableBody: "Puedes revisar vehículos similares en AutoMapa.",
  viewSimilar: "Ver similares",
  similarHeading: "Vehículos similares",
  similarSubheading: "Más opciones parecidas",
  viewMore: "Ver más vehículos",
};

/** Milestone 8 — layout copy */
export const VEHICLE_DETAIL_LAYOUT_COPY = {
  specsHeading: "Características del vehículo",
  summaryHeading: "Resumen",
  availabilityHeading: "Estado de la publicación",
  availabilityNote:
    "AutoMapa muestra la última información disponible. Antes de visitar el concesionario, confirma disponibilidad, precio y documentos.",
  fairPriceHeading: "Referencia de precio",
  fairPriceNoData: "Aún no tenemos suficientes comparables para este vehículo.",
  fairPriceDisclaimer:
    "Esta referencia ayuda a comparar publicaciones similares, pero no reemplaza una revisión del vehículo ni una negociación directa.",
  riskHeading: "Señales para revisar",
  riskNoData: "Sin evaluación disponible por ahora.",
  riskLowCopy: "No vemos señales importantes con la información disponible.",
  riskDisclaimer:
    "Estas señales no son acusaciones ni garantías. Úsalas como preguntas para hacer antes de comprar.",
  checklistHeading: "Antes de comprar, revisa esto",
  checklistSubheading:
    "Usa esta lista para hacer mejores preguntas antes de visitar o separar el vehículo.",
  checklistCta: "Ver checklist completo",
  share: "Compartir",
  copyLink: "Copiar enlace",
  linkCopied: "Enlace copiado",
  galleryEmpty: "Este vehículo no tiene fotos cargadas todavía.",
  imageUnavailable: "Imagen no disponible",
  dealerLabel: "Concesionario",
  contactWhatsapp: "Contactar por WhatsApp",
  contactSeller: "Contactar vendedor",
  requestInfo: "Solicitar información",
  callDealer: "Llamar",
  viewProfile: "Ver perfil",
  contactUnavailable: "Contacto no disponible",
  contactUnavailableNow: "Contacto no disponible por ahora.",
  mobileContact: "Contactar vendedor",
  mobileSimilar: "Ver similares",
  trustVerified: "Concesionario verificado",
  trustFairPrice: "Precio comparado",
  trustChecklist: "Checklist de compra",
  trustRisk: "Señales de riesgo",
  trustFreshness: "Disponibilidad actualizada",
};
